
// Query ElasticSearch using a LIT_Framework PHP API endpoint

let apiSearch = {};
apiSearch.input = {};
apiSearch.output = {};

// GET request to API
// ES query object created based on query string parameters
apiSearch.get = function (searchString) {
  const uri = searchUri(searchString)
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    mode: 'same-origin',
    cache: 'default'
  }
  if (app_environment !== 'prod') {
    console.log('GET query:', uri)
  }
  return fetch(uri, opts).then((response) => response.json())
    .then(response => getOut(response))
    .catch(error => getOut(error));
}

// POST request to API
// ES query object created based on query string parameters
// searchObj keys append to or replace top-level keys in the query object
apiSearch.post = function (searchString, searchObj) {
  const uri = searchUri(searchString)
  const opts = {
    method: 'POST',
    body: JSON.stringify(searchObj),
    headers: {
      'Content-Type': 'application/json'
    },
    mode: 'same-origin',
    cache: 'default'
  }
  if (app_environment !== 'prod') {
    // console.log('POST query:', uri, searchObj)
  }
  return fetch(uri, opts).then((response) => response.json())
    .then(response => getOut(response))
    .catch(error => getOut(error));
}

function searchUri(searchString) {
  // note: global vars are defined in config file, injected via webpack.
  let base_url = (app_base_url) ? app_base_url : window.location.origin;
  let api_base = (app_api_root) ? app_api_root : base_url;
  let api_endpoint = (app_api_endpoint) ? app_api_endpoint : '/search/api'

  let uri = api_base + api_endpoint + searchString;
  return uri;
}
// parse output
function getOut(response) {
  let res = {};
  // DEBUG //
  if (app_environment !== 'prod') {
    console.log('search response', response)
  }
  if (!response || response.exception) {
    console.log('query error:', response)
    let res = {
      error: response.status || "search error"
    }
  } else {
    res = {
      results: (response.hits) ? response.hits.hits : false,
      total: (response.hits) ? response.hits.total : false,
      aggs: (response.aggregations) ? response.aggregations : false,
    }
    // console.log("search response", res)
    return res;
  }
}

// module.exports = apiSearch;
export default apiSearch;


